import { render, staticRenderFns } from "./cardOauth.vue?vue&type=template&id=21144dec&scoped=true&"
import script from "./cardOauth.vue?vue&type=script&lang=js&"
export * from "./cardOauth.vue?vue&type=script&lang=js&"
import style0 from "./cardOauth.vue?vue&type=style&index=0&id=21144dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21144dec",
  null
  
)

export default component.exports